import React from 'react';
type Props = { src: string };

export const CustomLogo: React.FC<Props> = ({ src }: Props) => {
  return <img src={src} width="60px" alt="logo" />;
};
